import { createSelector } from 'reselect';

import {
  bikeTypesSelector,
  currencySelector
} from './app';

import makeBikeTypeNameSelector from './makers/makeBikeTypeNameSelector';

import {
  getPriceInCurrency,
  formatPrice,
  buildApiParams
} from 'utils';

import i18n from '../i18n';

const t = (...args) => i18n.t(...args);

const orderBikeSliceSelector = (state) => state.order.bike;

export const orderBikeSelector = createSelector(
  orderBikeSliceSelector,
  ({ item }) => item
);
export const orderBikeFetchingSelector = createSelector(
  orderBikeSliceSelector,
  ({ isFetching }) => isFetching
);
export const orderBikeErrorSelector = createSelector(
  orderBikeSliceSelector,
  ({ error }) => error
);
export const orderBikeInitialFetchingSelector = createSelector(
  orderBikeSelector,
  orderBikeFetchingSelector,
  (bike, fetching) => fetching && !bike
);

export const bikeTypeNameSelector = createSelector(
  orderBikeSelector,
  bikeTypesSelector,
  (bike, bikeTypes) => {
    if (bike && bikeTypes) {
      const bikeTypeId = bike.bikeType;
      const bikeType = bikeTypes.find(({ id }) => id === bikeTypeId);

      if (bikeType) {
        return bikeType.name;
      }
    }
  }
);

export const bikeTypeNameLocalizedSelector = makeBikeTypeNameSelector(
  createSelector(
    orderBikeSelector,
    (bike) => bike ? bike.bikeType : undefined
  )
);

export const bikeExtrasSelector = createSelector(
  orderBikeSelector,
  currencySelector,
  (bike, currency) => {
    const { company: { extraItems } } = bike;

    const translatedCurrency = t(currency);
    const translatedPerDay = t('day');

    return extraItems.map(({ id, price, onetimePayment, extraItemType }) => {
      const extras = {
        id,
        currency,
        onetimePayment,
        title: t(extraItemType && extraItemType.nameEn, { ns: 'extraItemTypes'})
      };

      if (price != null) {
        const priceValue = getPriceInCurrency(price, currency);

        extras.price = priceValue;
        extras.formatedPrice = t('for {{price}}\u00A0{{symbol}}{{perDay}}', {
          price: formatPrice(priceValue, currency),
          symbol: translatedCurrency,
          perDay: onetimePayment ? '' : `/${translatedPerDay}`,
          ns: 'detail'
        });
      } else {
        extras.price = 0;
        extras.formatedPrice = t('for free', { ns: 'detail' });
      }

      return extras;
    });
  }
);

const orderDetailsSlice = (state) => state.order.details;

export const bikeOrdersDetailsCountSelector = createSelector(
  orderDetailsSlice,
  ({ count }) => count
);
export const bikeOrdersDetailsExtrasSelector = createSelector(
  orderDetailsSlice,
  ({ extras }) => extras
);
export const bikeOrdersDetailsParamsSelector = createSelector(
  orderDetailsSlice,
  ({ period, params, count, extras }) => buildApiParams({
    count,
    extras,
    ...period,
    ...params
  })
);

export const bikeOrderDetailsSelector = createSelector(
  orderDetailsSlice,
  (details) => details.details.order
);
export const bikeOrderDetailsValidationSelector = createSelector(
  orderDetailsSlice,
  (details) => details.details.validation
);

export const newOrderSelector = createSelector(
  orderBikeSelector,
  orderDetailsSlice,
  (bike, details) => {
    if (!bike) {
      return;
    }

    const {
      count,
      extras,
      period,
      details: { order }
    } = details;

    return {
      bike: bike.id,
      beginTime: period.beginDateTime,
      endTime: period.endDateTime,

      // TODO: Server could extract this data from DB.
      //dropOffLocation: bike.company.city ? bike.company.city.id : 9443,
      count,
      userName: order.name,
      userEmail: order.email,
      userPhone: order.phone.replace(' ', ''),
      comment: order.comment,
      orderExtraItems: extras.map((extraItem) => ({ extraItem, count: 1}))
    };
  }
);

export const bikeDepositSelector = createSelector(
  orderBikeSelector,
  currencySelector,
  (bike, currency) => {
    if (!bike) {
      return undefined;
    }

    if (bike.company.bookingMode.toLowerCase() === 'free') {
      return null;
    }

    return {
      amount: getPriceInCurrency(bike.deposit, currency),
      currency
    };
  }
);



// WEBPACK FOOTER //
// ./src/selectors/bike.js